import React from 'react'
import { Progress } from 'antd'

import learnlogo from '../../assets/images/learnlogo.png'
import finishlogo from '../../assets/images/finish.png'
class ImagePath extends React.Component {
  render() {
    if (this.props.percent === 0) {
      return <img src={this.props.image} alt="logo" width={120} />
    } else if (this.props.percent < 100) {
      return (
        <>
          <img src={this.props.image} alt="logo" width={120} />
          <Progress
            type="circle"
            width={35}
            percent={this.props.percent}
            format={(percent) => {
              return (
                <img className="learnlogo" src={learnlogo} alt="logo"></img>
              )
            }}
          />
        </>
      )
    } else {
      return (
        <>
          <img src={this.props.image} alt="logo" width={120} />
          <img className="finishlogo" src={finishlogo} alt="logo"></img>
        </>
      )
    }
  }
}

export default ImagePath
